import React from "react"
import Select from "react-select"
import { FaFilter } from "react-icons/fa"

const StatusFilter = ({ selectedStatuses, onChange }) => {
	const statusOptions = [
		{ value: ["Completed"], label: "Completed" },
		{ value: ["Ongoing"], label: "Ongoing" },
		{ value: ["Scheduled", "Add on"], label: "Upcoming" },
		{ value: ["Cancellation", "No Show"], label: "No Show/Cancellation" }
	]

	// Handle onChange to clear selection if all options are selected
	const handleChange = selected => {
		if (selected && selected.length === statusOptions.length) {
			onChange([])
		} else {
			onChange(selected)
		}
	}

	return (
		<div className="w-auto z-50">
			<Select
				isMulti
				options={statusOptions}
				value={selectedStatuses}
				onChange={handleChange}
				placeholder={
					<div className="flex items-center">
						<FaFilter className="mr-2" />
						Filter by status...
					</div>
				}
				className="text-sm"
			/>
		</div>
	)
}

export default StatusFilter
